import React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import Tooltip from '@mui/material/Tooltip';

const StyColoredText = styled(Box, {
    name: 'StyColoredText',
})(({ theme }) => ({
    color: theme.palette.primary.main,
}));

type TooltipCellRendererParams = CellRendererParams<unknown, string> & {
    colored: boolean;
    bold?: boolean;
};

export default function TooltipCellRenderer({
    value,
    colored,
    bold,
}: TooltipCellRendererParams): React.ReactElement {
    return (
        <Tooltip title={value}>
            {colored ? (
                <StyColoredText>
                    {bold ? <b>{value}</b> : <>{value}</>}
                </StyColoredText>
            ) : (
                <div>{value}</div>
            )}
        </Tooltip>
    );
}
